import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  IconButton,
  Link,
  Grid,
  Chip,
  CircularProgress,
} from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import Iconify from "../iconify";
import Scrollbar from "../scrollbar";
import UserLevelChip from "../level/UserLevelChip";
import { fCoins, fCurrency } from "src/utils/formatNumber";
import CoinIcon from "../icons/CoinIcon";
import UserXpLevelIcon from "../icons/UserXpLevelIcon";

export default function UsersTable(props) {
  return (
    <Scrollbar>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>User ID</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>User Value</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Enabled</TableCell>
              <TableCell>Balance</TableCell>
              <TableCell>Revenue</TableCell>
              <TableCell>XP Level</TableCell>
              <TableCell>Signup</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!props.users.length ? (
              <TableRow>
                <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                  {props.loading ? <CircularProgress /> : "No results found"}
                </TableCell>
              </TableRow>
            ) : (
              props.users.map((row, index) => (
                <TableRow
                  key={index}
                  ref={
                    index === props.users.length - 1 ? props.lastUserRef : null
                  }
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.userId}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Link
                      href={`/dashboard/profile?user_id=${row.userId}`}
                      sx={{
                        textDecoration: "none",
                        color: "primary.main",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      {row.username.toString().length > 10
                        ? `${row.username.toString().slice(0, 10)}...`
                        : row.username.toString()}
                    </Link>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <UserLevelChip level={row.userLevelStats?.topPct} />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.firstName} {row.lastName}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.email.toString().length > 20
                      ? `${row.email.toString().slice(0, 20)}...`
                      : row.email.toString()}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.isEnabled ? (
                      <Iconify
                        icon={"eva:checkmark-circle-2-outline"}
                        sx={{ color: "green" }}
                      />
                    ) : (
                      <Iconify
                        icon={"eva:close-circle-outline"}
                        sx={{ color: "red" }}
                      />
                    )}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <CoinIcon />
                      {fCoins(row.balance)}
                    </div>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item xs={12}>
                        {fCurrency(row.revenue / 100)}
                      </Grid>
                      {row.isTester && (
                        <Grid item>
                          <Chip label="Tester" size="small" color="warning" />
                        </Grid>
                      )}
                    </Grid>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <UserXpLevelIcon levelName={row.levelName} />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {fDateTime(row.createdAt)}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="large"
                      color="inherit"
                      onClick={props.handleOpenMenu}
                      id={row.userId}
                    >
                      <Iconify icon={"eva:more-vertical-fill"} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Scrollbar>
  );
}
